//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdeKnihaPLA.ts						</Name>
//    <Description> Dialog seznam Kniha PLA										</Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-13                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvspla) GID:(Web.Set.Ts) V1:(ixs_pla,rok,ico,nazev,zkratka,poznamka,aktivita,ktg_akce,dat_zmena,zmenu_prov,cpps_msk,ixp_den_old,priz_az_def,priz_gen_cis,ixs_csp,priz_ram_doh) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

	/** dialog seznamu  */
	@gcontent
    export class SeznamAdeKnihaPLA extends GContentBase<SeznamAdeKnihaPLADesigner>  {

		//#region *** onContentReady && Init ***

		/** onContentReady */
        public onContentReady(): void {
            this.init();
		}

		/** init content */
		private init() {
			this.createMenuBar();
            // inicializace hodnot od rodice
            SeznamAdeKnihaPLADesigner.SeznamAdeKnihaPLADesignerInit(this, this.ixs_pla, this.rok, this.ico, false);
			this.setTitle();
            this.createGrid();
			this.createSidebar();
		}

		/** nastavit titulek dialogu */
		private setTitle() {
			this.title = "jres:29807943";
		}

		//#endregion

		//#region *** menubar ***

		private createContextBar(): MenuParams[] {
			return this.actions.createBar(["actDetail*", "actOpenInstitucionalniPredpokladPlan*", "actSeznamAdePovFunkcePlany*", "actSeznamAdeSubradaCiselAkci*", "actSeznamAdeProcesRealizaceKniha*", "actSeznamAdmVlastnostObecnyObjekt*"]);
		}


		private createMenuBar(): void {
			this.actions.addRange({
				actNovy: {
					icon: "gi-plus",
					caption: "jres:32000121",			//RC 32000121 : Nov� z�znam
					run: () => {
						var newRecord = true;
						this.openDetail(newRecord);
					}
				},
				actDetail: {
					icon: "gi-detail",
					caption: "jres:32131033",
					run: () => {
						this.openDetail();
					}
				},
				actReload: {
					icon: "gi-refresh",
					caption: "jres:33000084", //RC 33000084 : Obnovit
					run: () => {
						this.beginOperation()
						SeznamAdeKnihaPLADesigner.LoadData(this, this.ixs_pla, this.rok, this.ico);
						this.grid.ggrid("setData", this.view);
						this.endOperation();
					}
				},
				actOpenInstitucionalniPredpokladPlan: {
					icon: "fa-link",
					tooltip: "jres:29807982",
					caption: "jres:29807982",
					run: () => {
						this.openSeznamAdeInstitutPredpokladPlan();
					}
				},
				actSeznamAdePovFunkcePlany: {
					icon: "fa-link",
					caption: "jres:29807981",
					run: () => {
						this.openSeznamAdePovFunkcePlany();
					}
				},
				actSeznamAdeSubradaCiselAkci: {
					icon: "fa-link",
					caption: "jres:29807911",
					run: () => {
						this.openSeznamAdeSubradaCiselAkci();
					}
				},
				actSeznamAdeProcesRealizaceKniha: {
					icon: "fa-link",
					caption: "jres:33000166",
					run: () => {
						this.openSeznamAdeProcesRealizaceKniha();
					}
				},
				//actSeznamAdmVlastnostTypSubjektu: {
				//	icon: "fa-expand",
				//	caption: "jres:33000407",
				//	run: () => {
				//		this.openSeznamAdmVlastnostTypSubjektu();
				//	}
				//},
				actSeznamAdmVlastnostTypObjektu: {
					icon: "fa-expand",
					caption: "jres:33000417", //RC 33000417 : Nav�zan� pro v�echny
					tooltip: "jres:33000533", //RC 33000533 : Roz�i�uj�c� vlastnosti p�i�azen� v�em z�znam�m dan�ho business objektu
					run: () => {
						this.openSeznamAdmVlastnostTypObjektu();
					}
				},
				actSeznamAdmVlastnostObecnyObjekt: {
					icon: "fa-expand",
					caption: "jres:33000412",
					tooltip: "jres:33000534", //RC 33000534 : Roz�i�uj�c� vlastnosti p�i�azen� pouze konkr�tn�m z�znam�m
					run: () => {
						this.openSeznamAdmVlastnostObecnyObjekt()
					}
                }
			})
			this.menuBar(this.actions.createBar(
				["actReload*", "actNovy*", "actDetail*", {
					type: "static", caption: "jres:33000138", icon: "fa-link", favorite: true, children: [
						{
							action: this.actions.actOpenInstitucionalniPredpokladPlan,
						},
						{
							action: this.actions.actSeznamAdePovFunkcePlany,
						},
						{
							action: this.actions.actSeznamAdeSubradaCiselAkci,
						},
						{
							action: this.actions.actSeznamAdeProcesRealizaceKniha
						}
					]
				}, {
					type: "static", caption: "jres:33000415", icon: "fa-expand", favorite: true, children: [ //RC 33000415 : Vlastnosti
						{
							action: this.actions.actSeznamAdmVlastnostTypObjektu
						},
						{
							action: this.actions.actSeznamAdmVlastnostObecnyObjekt
						}
				    ]
                }],
			));
		}

		//#region *** detail ***

		/**
		 * otev��t detail
		 */
        private openDetail(_new?: boolean): void {

            var newRecord = _new == null ? false : _new;

                if (newRecord === true) {
                    // nov� z�znam p�i pr�zdn�m gridu
                    Dialogs.DetailAdeKnihaPLADlg(this, { ixs_pla: this.ixs_pla, rok: this.rok, ico: this.ico, grid: this.grid, newRecord: newRecord }).done((data: any) => {     });
                }
				else if (Utils.isGridEmpty(this.grid)) {
					SeznamBase.createWarningNot(this, { title: "jres:29807943", text: "jres:32131036", id: "id-flash-select-more-rows-grid-detail" })
                }
            else {

				var selection = this.grid.ggrid("getSelection");

                // vybran� jeden ��dek
				if (selection.length === 1) {
                    var data: any = selection[0];
                    Dialogs.DetailAdeKnihaPLADlg(this, { ixs_pla: data.ixs_pla, rok: data.rok, ico: data.ico, grid: this.grid, newRecord: newRecord }).done((data: any) => {         });
                }

				// vybr�no v�ce ��dk�
				else {
					SeznamBase.createWarningNot(this, { title: "jres:29807943", text: "jres:32131037", id: "id-flash-select-more-rows-grid-detail" })
				}
			}

		}

		//#endregion

		//#region *** grid ***

		/** vytvo�it seznam - definice objektu GRIDu, nav�zan�ch ud�lost� atd... */
		private createGrid(): void {

            this.grid = $("<div>").gautofit().appendTo(this.element);

			this.grid.ggrid({
				data: this.view,
				name: "gridSeznam",
				dataKey: "ixs_pla",
				renderMode: "auto",										// auto, all-at-once, paged-sync, paged-async
				columnMode: "full",										// fit (defaultne by melo byt toto), full
				customClass: "ts-grid-seznam-class",
				navigationMode: "row",									// row, cell
				defaultAction: this.actions.actDetail,
				searchColumns: this.gridSearchColumns,
				columns: this.gridFormat,
				contextMenu: this.createContextBar(),					// contextov� menu
                sort: "ixs_pla",									    // �azen� seznamu 
				selection: (ev, obj) => {
					this.actions.actOpenInstitucionalniPredpokladPlan?.update({ enabled: obj.count == 1 })
					this.actions.actDetail?.update({ enabled: obj.count == 1 })
					this.actions.actSeznamAdePovFunkcePlany?.update({ enabled: obj.count == 1 })
					this.actions.actSeznamAdeSubradaCiselAkci?.update({ enabled: obj.count == 1 })
					this.row = obj.getSelection();
					this.refreshPanel();
				}
			});

		}

		//#endregion

		//#region *** sidebar ***

		/** vytvo�it sidebar */
		private createSidebar() {
			this.removeSidebar();
			var panel = this.createPanel();
			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: [panel]
				}
			});
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/**  vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {
			this.panelId = "panelNahledSeznam";
			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
				leaf: "jres:32131038",								//RC 32131038 : N�hled
				icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel($(ev.target))
				},
			} as GSideBarPanelOptions;
			return panel;
		}

		/** refresh panelu */
		private refreshPanel(elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.closed) {		// o�et�en� zav�en� contentu
				return;
			}

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}
			if (panel !== undefined) {
				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}
				this.panelElement = $("<div>").appendTo(panel);
				GridUtils.setPanelGrid("jres:32131039", this.row, this.gridFormat, this.panelElement); //RC 32131039 : Seznam
			}
		}

		//#endregion

		private openSeznamAdeInstitutPredpokladPlan() {
			var selection = this.grid.ggrid("getSelection");
			if (selection.length == 1)
				this.navigate(["Gordic.Adm.WebControls.SeznamAdeInstitutPredpokladPlan"], { Id: "SeznamAdeInstitutPredpokladPlan", ixs_pla: selection[0].ixs_pla });
		}

		private openSeznamAdePovFunkcePlany() {
			var selection = this.grid.ggrid("getSelection");
			if (selection.length == 1)
			    this.navigate(["Gordic.Adm.WebControls.SeznamAdePovFunkcePlany"], { Id: "SeznamAdePovFunkcePlany", ixp_den: selection[0].ixs_pla })
		}

		private openSeznamAdeSubradaCiselAkci() {
			var selection = this.grid.ggrid("getSelection");
			if (selection.length == 1)
				this.navigate(["Gordic.Adm.WebControls.SeznamAdeSubradaCiselAkci"], { Id: "SeznamAdeSubradaCiselAkciy", ixs_pla: selection[0].ixs_pla, rok: selection[0].rok, ico: selection[0].ico })
		}

		private openSeznamAdeProcesRealizaceKniha() {
			var selection = this.grid.ggrid("getSelection");
			if (selection.length == 1)
				this.navigate(["Gordic.Adm.WebControls.SeznamAdeProcesRealizaceKniha"], { Id: "SeznamAdeProcesRealizaceKniha", ixs_pla: selection[0].ixs_pla })
		}

		//private openSeznamAdmVlastnostTypSubjektu() {
		//	this.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypSubjektu"], {
		//		Id: "SeznamAdmVlastnostTypSubjektu",
		//		typ_obj: this.dataListDescription.typ_obj,
		//		ico: this.ico
		//	})
		//}

		private openSeznamAdmVlastnostTypObjektu() {
			this.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypObjektu"], {
				Id: "SeznamAdmVlastnostTypObjektu",
				typ_obj: this.dataListDescription.typ_obj,
				ico: this.ico
			})
		}

		private openSeznamAdmVlastnostObecnyObjekt() {
			var selection = this.grid.ggrid("getSelection");
			if (selection.length == 1)
				this.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostObecnyObjekt"], { Id: "SeznamAdmVlastnostObecnyObjekt", typ_obj: this.dataListDescription.typ_obj, sxs: selection[0].ixs_pla, ico: selection[0].ico, nazev: "{0} - {1}".format(selection[0].rok, selection[0].nazev) })
        }
	}
}
